module.exports = __webpack_public_path__ + "static/media/kg.3b4af147.svg";